import * as React from 'react';
import AsyncVirtualized from '../AsyncVirtualized';
import withTable from './withTable';
const ReduxTable = withTable()(
  ({
    tableOptions: {props: optionsProps},
    onSetFilterOpen,
    filterOpen,
    onFilterChange,
    onClearFilter,
    name,
    filterRenderButtons,
    ...props
  }) => {
    if (!props.columnsConfig) {
      // means do not render table before SET_INITIAL_TABLE_STATE action is done
      return null;
    }
    const {filterProps, ...otherProps} = optionsProps;
    return (
      <AsyncVirtualized
        {...otherProps}
        {...props}
        filterProps={{
          onChange: onFilterChange,
          onSetOpen: onSetFilterOpen,
          open: filterOpen,
          renderButtons: filterRenderButtons,
          onClear: onClearFilter,
          ...filterProps,
        }}
        persistenceKey={name}
      />
    );
  }
);

export default ReduxTable;
